import React, { Component } from 'react';
import {Link}from 'react-router-dom';

// images

import InfoJumb1 from './images/infoJumbo1.jpg';
import InfoJumb2 from './images/infoJumbo2.jpg';
import InfoJumb3 from './images/infoJumbo3.jpg';

import banner1 from './images/banner1.jpg';

import {Grid, Row, Col, Carousel, Breadcrumb, Button} from 'react-bootstrap';

class nordlockMain extends Component {
  render() {
    return (
      <div className='container-fluid'>
        <div className="supMainLS">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/Zubehoer">Zubehör</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>NORD-LOCK</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <img src={banner1} alt="NordLock Superbolt"/>
        </div>
        <div className="supMainTextLS">
          <h1>NORD-LOCK</h1>
          <Grid className="supMainInfo">
          <Row>
            <Col xsHidden smHidden md={5}>
              <Carousel  controls={false} interval={3000}>
                <Carousel.Item >
                    <img  src={InfoJumb1}  alt="NordLock Superbolt Spannmutter"  height="100%" />
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb2} alt="NordLock Superbolt Kernfusion"  height="100%"/>
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb3} alt="NordLock Superbolt Heavy Duty"  height="100%" />
                </Carousel.Item>
              </Carousel>
              </Col>
            <Col xsHidden md={7}>
              <h4>Die Nord-Lock Group ist ein weltweit führender Anbieter sicherer Verschraubungslösungen. Superbolt Spannelemente bieten einfache und kostengünstige Spannverfahren für großformatige Bolzen. Verbindungen können mit hoher Genauigkeit angezogen werden, ohne dass besondere Fachkenntnisse benötigt werden. Superbolt Spreizbolzen gewährleisten durch die radiale Aufweitung der Konushülse stets den flächigen Kontakt zur Bohrung.

Die Konstruktion erlaubt präzise Vorspannung in radialer und axialer Richtung, wodurch Mikrobewegungen in der Teilfuge verhindert werden und damit auch Folgeschäden an Bolzen und Bohrungen.

Durch nachrüsten von Spreizbolzen können herkömmliche Passbolzen zuverlässig und kostengünstig ersetzt werden.</h4>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden>
              <h4>Die Nord-Lock Group ist ein weltweit führender Anbieter sicherer Verschraubungslösungen. Superbolt Spannelemente bieten einfache und kostengünstige Spannverfahren für großformatige Bolzen. Verbindungen können mit hoher Genauigkeit angezogen werden, ohne dass besondere Fachkenntnisse benötigt werden.
            </h4>
            </Col>
            <Col xs={12} md={{ span: 7, offset: 2 }}>
              <Button className="supMainButtonWebPage" variant="light" href="https://www.nord-lock.com/de-de/superbolt/" target="_blank">Hersteller Homepage</Button>
            </Col>
          </Row>
        </Grid>
      </div>
        <br/>
          <section>
          <div className="supMainKeyWords White">
            <br/>
            <Grid>
              <Row>

              </Row>
              <br/>
              <Row className="show-grid">


              </Row>
            </Grid>
            <br/>
          </div>
          <br/>
        </section>

        </div>
    );
  }
}

export default nordlockMain;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/nordlock/mainPageSup.js